import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageAdminTeams
{
    constructor(targetElement)
    {
        const url = new URL(window.location.href);
        const limit = url.searchParams.get("l") || 50;
        const offset = url.searchParams.get("o");
        let pagination = targetElement.dataset.pagination;
        pagination = web.parseDustJson(pagination, {});

        web.tabs.initPagination(ele.byQuery(".adminTeamsPagination"), pagination, limit, offset, (newLimit, newOffset) =>
        {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set("l", newLimit);
            searchParams.set("o", newOffset);
            window.location.search = searchParams.toString();
        });
    }
}
